import { render, staticRenderFns } from "./NavDisplayWidget.vue?vue&type=template&id=385fe7b2&scoped=true&"
import script from "./NavDisplayWidget.vue?vue&type=script&lang=js&"
export * from "./NavDisplayWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385fe7b2",
  null
  
)

export default component.exports